import React from 'react'
import { Icon, type IconName } from './Icon'

export function Endpoint({ children }: { children: React.ReactNode }) {
  return (
    <span className="endpoint-tag" title="Backend endpoint">
      {children}
    </span>
  )
}

export function Card({
  icon,
  title,
  endpoint,
  right,
  bodyPad = true,
  children,
  style,
  className,
}: {
  icon?: IconName
  title?: string
  endpoint?: string
  right?: React.ReactNode
  bodyPad?: boolean
  children?: React.ReactNode
  style?: React.CSSProperties
  className?: string
}) {
  const hasHead = title || icon || endpoint || right
  return (
    <div className={`card${className ? ' ' + className : ''}`} style={style}>
      {hasHead && (
        <div className="head">
          {icon && <Icon name={icon} size={13} />}
          {title && <span className="title">{title}</span>}
          <span className="grow" />
          {endpoint && <Endpoint>{endpoint}</Endpoint>}
          {right}
        </div>
      )}
      {bodyPad ? <div className="body">{children}</div> : children}
    </div>
  )
}

export function Pill({
  variant = 'ghost',
  children,
  style,
}: {
  variant?: 'admin' | 'live' | 'ok' | 'warn' | 'err' | 'info' | 'ghost'
  children: React.ReactNode
  style?: React.CSSProperties
}) {
  return (
    <span className={`pill ${variant}`} style={style}>
      {children}
    </span>
  )
}

export function StatusDot({
  tone = 'dim',
  style,
}: {
  tone?: 'ok' | 'warn' | 'err' | 'info' | 'dim'
  style?: React.CSSProperties
}) {
  return <span className={`dot ${tone}`} style={style} aria-hidden />
}
